<!--
    描述：header 部分右侧
    时间：2020-04-22
    Created by ws
-->
<template>
	<!-- 个人信息 及 工具栏 -->
	<div class="userInfo-container">
		<div class="btn-groups mr10">
			<!-- 全屏 -->
			<screen-full class="tool-btn"></screen-full>

			<!-- 引导 -->
			<!-- <guide class="tool-btn"></guide> -->

			<!-- 更改主题色 -->
			<ThemePicker class="tool-btn"></ThemePicker>

			<!-- 设置是否展示头部 -->
			<!-- <setting class="tool-btn"></setting> -->
		</div>
		<div class="avatar-box"
			 v-if="userInfo.avatar">
			<!-- <img src="@/assets/images/avatar.png"
					 alt=""> -->
			<img :src="userInfo.avatar"
				 alt="">
		</div>
		<div class="text-overflow">
			<template v-if="userInfo.sname === '系统用户'">
				<span class="info-text pdr10">{{ userInfo.sname }}</span>
			</template>
			<template v-else>
				<el-dropdown @command="handleCommand"
						 class="info-text">
					<span class="el-dropdown-link">
						{{ userInfo.sname }}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="password">修改密码</el-dropdown-item>
						<el-dropdown-item command="logOut">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>
		</div>
		<!-- 修改密码弹窗 -->
		<el-dialog
				class="show-accreditImg"
				center
				:title="dialogObj.title"
				:visible.sync="dialogObj.visible"
				:width="dialogObj.width"
				:close-on-click-modal="false"
				append-to-body
				destroy-on-close>
			<!-- 弹窗组件 -->
			<changePassword
					ref="changePassword"
					v-if="dialogObj.visible"
					@dialogClose="handleClose"></changePassword>
			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button class="btn cancel-btn" size="small" @click="dialogObj.visible = false">取 消</el-button>
				<el-button class="btn btn-blue" type="primary" size="small" @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import guide from '@/components/guide/guide'
import screenFull from '@/components/screenFull'
import setting from '@/components/globalSetting'
import ThemePicker from '@/components/themePicker/ThemePicker'
import changePassword from './change_password'
import { mapState, mapActions } from 'vuex'

export default {
	components: {
		guide,
		screenFull,
		setting,
		ThemePicker,
		changePassword
	},
	data() {
		return {
			dialogObj: {
				title: "修改密码",
				visible: false,
				width: "500px",
			},
		}
	},
	methods: {
		...mapActions('user', ['loginOut']),
		// 个人信息下拉框事件
		handleCommand(command) {
			switch (command) {
				case 'logOut':
					// this.$router.push({
					// 	path: '/login'
					// })
					// return
					this.loginOut()
						.then(() => {
							this.$router.push({
								path: '/login'
							})
							setTimeout(() => {
								this.$message.success('退出成功!')
							}, 500)
						})
						.catch(() => {
							// this.btnLoading = false
						})
					break;
				case'password':
					this.dialogObj.visible = true;
					break;
				default:
					return
			}
		},
		doSave(){
			this.$refs.changePassword.sumbitPass();
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false;
		},
	},
	computed: {
		...mapState('user', {
			userInfo: state => state.userInfo
		})
	}
}
</script>

<style scoped lang="less">
</style>
